module.exports = __webpack_public_path__ + "static/tulsa-3.34ee27d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/tulsa-3.jpg
// module id = 151
// module chunks = 35783957827783 155329947031394